import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=01ed3dd0&scoped=true&"
import script from "./shipping.js?vue&type=script&lang=js&"
export * from "./shipping.js?vue&type=script&lang=js&"
import style0 from "./shipping.scss?vue&type=style&index=0&id=01ed3dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed3dd0",
  null
  
)

export default component.exports